// extracted by mini-css-extract-plugin
export default {"JoinShowLegal":"JoinShowPanel_JoinShowLegal__tcp9s"};